
import React, {useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {getGoogleSheet, getMyPrediction, getSymbolList } from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import { useDispatch } from "react-redux";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { setDeliveryDateReducer } from "../redux/slice/deliveryDate";
import { useNavigate } from "react-router-dom";
import { NSE_filter_volume } from "../utils/constants";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { degAngle } from "../utils/utilsFunctions";



const HotStarSymbolsPage = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [symbolData, setSymbolData] = useState([]);
    const [predictionData, setPredictionData] = useState([]);
    const [getGroupSectors, setGroupSectors] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [prevFilteredData, setPrevFilteredData] = useState([]);
    const [todayData, setTodayData] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [series, setSeries] = useState('EQ');
    const [sector, setSector] = useState('All');
    const [indices, setIndices] = useState('All');
    const [listingDate, setListingDate] = useState('All');
    const NSE_Past_date = useSelector((state) => state.pastDate.value);
    // const [startDate, setStartDate] = useState(NSE_Past_date[0].max_date);
    const [startDate, setStartDate] = useState(new Date());
    const [currentSort, setCurrentSort] = useState(false);
    const [ROE, setROE] = useState('ROE');
    const [priceCAGR, setPriceCAGR] = useState('priceCAGR');
    const userToken = useSelector((state) => state.userToken.value);
    const navigate = useNavigate();
    const [todayTime, setTodayTime] = useState([]);
    

    useEffect(() => {
        if(userToken){
            let current_date = moment(startDate).format('DDMMYY');
            dispatch(setDeliveryDateReducer(startDate));
            
            getSymbolList(series, '', userToken).then(function (response) {
                setSymbolData(response.data.data);
                // setLoader(true);
            }).catch(function (err) {console.log("Error", err) });

            getMyPrediction(current_date, userToken).then(function (response) {
                setPredictionData(response.data.data);
            }).catch(function (err) {console.log("Error", err) });

            getGoogleSheet('', userToken).then(function (response) {
                setTodayTime(response.data.data.datetime);
                setTodayData(response.data.data.json_data);
            }).catch(function (err) {console.log("Error", err) });  
        }else{
            navigate(`/`);
        }

    }, [userToken, startDate, series]);

    useEffect(() =>{
        setLoader(false);

        if(symbolData && symbolData && predictionData){

                const uniqueSectors = [...new Set(
                    symbolData
                        .filter(item => item.series === series && item.group_sector && item.group_sector.trim() !== '')
                        .map(item => item.group_sector.trim())
                    )].sort();


         
                setGroupSectors(uniqueSectors);

                const filtered = symbolData.filter((obj) => {
                    setLoader(true);
                    return ( 
                        obj.series === series
                        // && parseFloat(obj.ROCE) > 15
                        // For Stock Price 
                        && parseFloat(obj.priceCAGR_1Y) > 5
                        // && parseFloat(obj.priceCAGR_3Y) > 5

                        // For Return on Equity
                        && parseFloat(obj.ROE) > 15 // ****
                        // && parseFloat(obj.roeCAGR_3Y) > 5
                        // && parseFloat(obj.roeCAGR_5Y) > 5
                        && predictionData?.find(p => p.symbol === obj.symbol 
                                && !isNaN(parseFloat(p.price_14_date_PL)) && parseFloat(p.price_14_date_PL) > 10 
                                
                                // && parseFloat(p.sma_angle_5) > 0  && parseFloat(p.sma_angle_9) > 0 && parseFloat(p.sma_angle_14) > 0
                                // && parseFloat(p.sma_angle_5) > parseFloat(p.sma_angle_9)  && parseFloat(p.sma_angle_9) > parseFloat(p.sma_angle_14)
                                && parseFloat(p.rsi) < 80 
                                && parseFloat(p.adx) > 30 
                                && parseInt(p.avg_volume) > NSE_filter_volume
                                && p.trueAvgVolume === true
                        )
                        && todayData?.find(p => p.TICKER === obj.symbol && !isNaN(parseInt(p.MARKETCAP)) && parseInt(p.MARKETCAP) >= 5000000000)
                    );
                });
                        

            setFilteredData(filtered);
            setPrevFilteredData(filtered);
        }

    },[symbolData, todayData, predictionData, series])


    const dataSortBy = (filterType, sortby) => {
        let currentSort = sortby;
        setCurrentSort(sortby);
        const sortedData = [...filteredData];
        if(filterType === "down_now"){
            sortedData.sort((a, b) => {
                
                let close_price_A = todayData.find(item => item.TICKER === a.symbol)?.LTP || 0;
                let close_price_B = todayData.find(item => item.TICKER === a.symbol)?.LTP || 0;
            
                let percentageA = close_price_A ? ((a.high52w - close_price_A) * 100) / a.high52w : 0;
                let percentageB = close_price_B ? ((b.high52w - close_price_B) * 100) / b.high52w : 0;
            
                // return percentageA - percentageB;
                if(currentSort === true){
                    return percentageA - percentageB;
                }else{
                    return percentageB - percentageA;
                }
            });
        }
        else if(filterType === "change"){
            sortedData.sort((a, b) => {
                let change_A = todayData.find(item => item.TICKER === a.symbol)?.CHANGEPER || 0;
                let change_B = todayData.find(item => item.TICKER === b.symbol)?.CHANGEPER || 0;               
                if(currentSort === true){
                    return change_B - change_A;
                }else{
                    return change_A - change_B;
                }
            });
            
        }
        else if(filterType === "sector"){
            sortedData.sort((a, b) => {
                if (a.series === "ETF" && b.series !== "ETF") return -1;
                if (a.series !== "ETF" && b.series === "ETF") return 1;
                // return a.group_sector.localeCompare(b.group_sector); // Sorting alphabetically by sector
                if(currentSort === true){
                    return a.group_sector.localeCompare(b.group_sector);
                }else{
                    return b.group_sector.localeCompare(a.group_sector);
                }
            });
        }
        else if(filterType === "low52"){
            if(currentSort === true){
                    sortedData.sort((a, b) => new Date(b.lowDate) - new Date(a.lowDate));
                }else{
                    sortedData.sort((a, b) => new Date(a.lowDate) - new Date(b.lowDate));
            }
        }

        else if(filterType === "high52"){
            if(currentSort === true){
                    sortedData.sort((a, b) => new Date(b.highDate) - new Date(a.highDate));
                }else{
                    sortedData.sort((a, b) => new Date(a.highDate) - new Date(b.highDate));
            }
            
        }

        
        else if(filterType === "listing"){
                if(currentSort === true){
                    sortedData.sort((a, b) => new Date(b.listingDate) - new Date(a.listingDate));
                }else{
                    sortedData.sort((a, b) => new Date(a.listingDate) - new Date(b.listingDate));
                }
            
        }

        else if(filterType === "delivery"){
            sortedData.sort((a, b) => {
                let change_A =  predictionData.find(item => item.symbol === a.symbol)?.delivery_per || 0;
                let change_B =  predictionData.find(item => item.symbol === a.symbol)?.delivery_per || 0;
                if(currentSort === true){
                    return change_B - change_A;
                }else{
                    return change_A - change_B;
                }
            });
            
        }

        else if (filterType === "14days"){
                sortedData.sort((a, b) => {
                    let conditionA = predictionData.find(item => item.symbol === a.symbol)?.price_14_date_PL || 0;
                    let conditionB = predictionData.find(item => item.symbol === b.symbol)?.price_14_date_PL || 0;
                    if(currentSort === true){
                        return conditionB - conditionA;
                    }else{
                        return conditionA - conditionB;
                    }
                });
        }

        else if (filterType === "angle"){
                sortedData.sort((a, b) => {
                    let conditionA = predictionData.find(item => item.symbol === a.symbol)?.sma_angle_14 || 0;
                    let conditionB = predictionData.find(item => item.symbol === b.symbol)?.sma_angle_14 || 0;
                    if(currentSort === true){
                        return conditionB - conditionA;
                    }else{
                        return conditionA - conditionB;
                    }
                    
                });
        }

        else{          
            // console.log("filterType>>>", filterType);  
            if(currentSort === true){
                sortedData.sort((a, b) => b[filterType] - a[filterType]);
            }else{
                sortedData.sort((a, b) => a[filterType] - b[filterType]);
            }
        }
        setFilteredData(sortedData);
      };

return (
    <React.Fragment>
        <div className="pageContainer">
        {
            (loader === false? <PageLoader />: 
            <React.Fragment>
                <div className="pagewrap fullheight">
                <table className="table table-bordered frozen-table symbolList">
                    <thead>
                        <tr>
                            <th colSpan={2} style={{Width:'200px'}}>Symbol</th>
                            {/* {/* <th></th> */}
                            <th style={{minWidth:'15px'}}></th>
                            <th style={{minWidth:'40px' , textAlign:'left'}}>Strength</th>
                            <th style={{minWidth:'45px', textAlign:'left'}}>Series</th>
                            <th style={{minWidth:'150px', textAlign:'left'}}>Sector <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('sector', !currentSort)}}></button></th>
                            <th style={{minWidth:'150px', textAlign:'left'}}>Industry</th>
                            <th style={{minWidth:'60px', textAlign:'left'}}>Indices</th>
                            <th style={{minWidth:'140px'}} colSpan={2}>LTP | Chn% [{moment(todayTime).format('HH:mm')}] <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('change', !currentSort)}}></button></th>
                            <th style={{minWidth:'80px'}}>14D P/L <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('14days', !currentSort)}}></button></th>
                            <th style={{minWidth:'140px'}} title="Deg">14 | 9 | 5 Deg&deg; <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('Deg', !currentSort)}}></button></th>
                            <th style={{minWidth:'70px'}}>SMA200</th>
                            <th style={{minWidth:'85px'}}>52 Down <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('down_now', !currentSort)}}></button></th>
                            <th style={{minWidth:'125px'}}>52 High <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('high52', !currentSort)}}></button></th>
                            <th style={{minWidth:'125px'}}>52 Low <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('low52', !currentSort)}}></button></th>
                            <th style={{minWidth:'110px'}}>Del% <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('delivery', !currentSort)}}></button></th>
                            {/* <th style={{minWidth:'125px'}}>Listing Date <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('listing', !currentSort)}}></button></th> */}
                            <th style={{minWidth:'85px'}} title="Price CAGR%">P CAGR <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy(priceCAGR, !currentSort)}}></button></th>
                            <th style={{minWidth:'65px'}}>ROE <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy(ROE, !currentSort)}}></button></th>
                            <th style={{minWidth:'70px'}}>ROCE <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('ROCE', !currentSort)}}></button></th>
                            <th style={{minWidth:'65px'}}>PE <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('PE', !currentSort)}}></button></th>
                            <th style={{minWidth:'65px'}}>EPS <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('EPS', !currentSort)}}></button></th>                            
                            <th style={{minWidth:'120px'}}>MarketCap <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('MarketCap', !currentSort)}}></button></th>
                            <th style={{minWidth:'95px'}}>Promoter <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('Promoter_holding', !currentSort)}}></button></th>
                            <th style={{minWidth:'70px'}}>FII <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('FII_holding', !currentSort)}}></button></th>
                            <th style={{minWidth:'70px'}}>DII <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('DII_holding', !currentSort)}}></button></th>
                            <th style={{minWidth:'120px'}}>Government <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('Government_holding', !currentSort)}}></button></th>                            
                            <th style={{minWidth:'200px'}}>Events</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                    
                    {filteredData?.map((item, index)=>{
                        const symbolName = item.symbol;
                        let todayLTP = todayData.find((item, index) => item.TICKER === symbolName);
                        let prediction =  predictionData.find((item, index) => item.symbol === symbolName);
                        let prevVolume = (((parseInt(prediction?.ttl_trd_qty) - parseInt(prediction?.prev_ttl_trd_qty)) * 100)/parseInt(prediction?.prev_ttl_trd_qty)).toFixed(2);
                        let angle_5 = degAngle(prediction?.price_5, todayLTP?.LTP, 5);
                        let angle_9 = degAngle(prediction?.price_9, todayLTP?.LTP, 9);
                        let angle_14 = degAngle(prediction?.price_14, todayLTP?.LTP, 14);
                        return(
                            <>
                                <tr className={`tr_${item.id}`} key={`row_item_${index+1}`} id={`row_item_${index}`}>
                                    <td className="symbolName">{symbolName} {item.hotStar === '1'? <span className="hotStar"></span>:null}</td>
                                    <td><DeliveryGraph symbol={symbolName} todayLTP={todayLTP} date={moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD')}/></td>
                                    <td><StockAction symbol={symbolName} delivery={false} currentPrice ={todayLTP?.LTP} deliveryPer={prediction?.delivery_per} hotStar={item.hotStar} myFev={item.myFev} eventName = "Symbol" rowId = {`row_item_${index}`} /></td>
                                    {
                                        (todayLTP && prediction)?
                                            <StockStrength id= {`s_${item.id}`} selectedDate={startDate} symbol={symbolName} todayLTP={todayLTP} details={item} predictions={prediction}  />
                                    : <td>&nbsp;</td>
                                    }
                                    <td style={{textAlign:'left'}}>{item.series} </td>
                                    <SectorPanchang symbol={symbolName} sector={item.group_sector} todayData={todayData} symbolData={symbolData} tag = "td" align = "right" durationDays = "" />
                                    <td style={{textAlign:'left', lineHeight:'1.1'}}>{item.industry}</td>
                                    <td className="indices" style={{ textAlign: 'left' }}>
                                        {(() => {
                                                const label = item.nifty50? '50': item.nifty100? '100': item.nifty200? '200': item.nifty500? '500': item.totalMarket? 'TM': '';
                                                const excludedSeries = ['ETF', 'BOND', 'MF'];
                                                const showFev = item.myFev && !excludedSeries.includes(item.series);
                                                return label + (showFev ? `${label ? ', ' : ''}Fev` : '');
                                        })()}
                                    </td>

                                    <td style={{textAlign: 'right'}}>{todayLTP?.LTP}</td>
                                    <td style={{width: '45px', textAlign: 'right',  color: todayLTP?.CHANGEPER > 0 ? '#1c8b16' : '#f00'}}>{todayLTP?.CHANGEPER}%</td>
                                    <td style={{textAlign:'right'}} title={`${prediction?.price_14} | ${moment(prediction?.price_14_date).format('DD/MM/YYYY')}`}>{prediction?.price_14_date_PL}%</td>
                                    <td style={{textAlign:'right', backgroundColor: (parseFloat(angle_5) > parseFloat(angle_9)) && (parseFloat(angle_9) > parseFloat(angle_14))? '#e9ffe3':''}}>
                                            {angle_14}&deg; | {angle_9}&deg; | {angle_5}&deg;
                                    </td>
                                    <td style={{textAlign:'right', background: parseFloat(prediction?.sma50) > parseFloat(prediction?.sma200)? "#e2ffe5":"#fff8f8" }} title={`DMA50: ${prediction?.sma50}`}>{prediction?.sma200}</td>
                                    <td style={{textAlign:'right'}}>{todayLTP?.LTP? ((item.high52w - todayLTP?.LTP)*100/item.high52w).toFixed(2): ''}</td>
                                    <td style={{textAlign:'right'}}>{item.high52w} | {moment(item.highDate).format('DD/MM/YY')}</td>
                                    <td style={{textAlign:'right'}}>{item.low52w} | {moment(item.lowDate).format('DD/MM/YY')}</td>                                    
                                    <td style={{textAlign:'right', background: (prediction?.delivery_spike === "Delivery Spike" && prevVolume > 100)?"#e9ffe3":""}} title={prediction?.avg_volume}>{prevVolume} | {prediction?.delivery_per}%</td>
                                    <td style={{textAlign:'right'}}>{priceCAGR === 'priceCAGR_10Y'? item.priceCAGR_10Y: priceCAGR === 'priceCAGR_5Y'? item.priceCAGR_5Y: priceCAGR === 'priceCAGR_3Y'? item.priceCAGR_3Y:item.priceCAGR_1Y}</td>
                                    <td style={{textAlign:'right'}}>{ROE === 'roeCAGR_10Y'? item.roeCAGR_10Y: ROE === 'roeCAGR_5Y'? item.roeCAGR_5Y:ROE === 'roeCAGR_3Y'? item.roeCAGR_3Y:item.ROE}</td>
                                    <td style={{textAlign:'right'}}>{item.ROCE}</td>
                                    <td style={{textAlign:'right'}}>{item.PE}</td>
                                    <td style={{textAlign:'right'}}>{item.EPS}</td>                                    
                                    <td style={{textAlign:'right'}}>{item.MarketCap}</td>
                                    <td style={{textAlign:'right'}}>{item.Promoter_holding}</td>
                                    <td style={{textAlign:'right'}}>{item.FII_holding}</td>
                                    <td style={{textAlign:'right'}}>{item.DII_holding}</td>
                                    <td style={{textAlign:'right'}}>{item.Government_holding}</td>
                                    <td style={{textAlign:'left'}}>{item.events}</td>
                                </tr>
                                
                            </>
                        ) 
                        
                    })
                    
                    }
                    </tbody>
                </table>
                </div>
            </React.Fragment>
            )
        }
        </div>
    </React.Fragment>
)

}
export default HotStarSymbolsPage;